function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FBD0D0",
  d: "M21.5 11c0 5.8-4.701 10.5-10.5 10.5C5.2 21.5.5 16.8.5 11S5.2.5 11 .5C16.799.5 21.5 5.2 21.5 11z"
}), React.createElement("path", {
  fill: "#EC1212",
  d: "M11 .994C5.473.994.993 5.473.993 11S5.473 21.007 11 21.007c5.527 0 10.007-4.48 10.007-10.007C21.007 5.473 16.527.994 11 .994zM.007 11C.007 4.928 4.929.007 11 .007 17.07.007 21.993 4.928 21.993 11S17.071 21.994 11 21.994C4.929 21.994.007 17.072.007 11z"
}), React.createElement("g", {
  transform: "translate(12.897 9.862)"
}, React.createElement("path", {
  fill: "#EC1212",
  d: "M2.411 2.28c0 .925-.496 1.673-1.107 1.673C.69 3.953.195 3.205.195 2.28c0-.923.496-1.672 1.109-1.672.611 0 1.107.749 1.107 1.672z"
})), React.createElement("g", {
  transform: "translate(6.828 9.862)"
}, React.createElement("path", {
  fill: "#EC1212",
  d: "M2.6 2.335c0 .953-.512 1.726-1.144 1.726-.63 0-1.142-.773-1.142-1.726S.826.609 1.456.609c.632 0 1.144.773 1.144 1.726z"
})), React.createElement("g", {
  transform: "translate(7.586 15.172)"
}, React.createElement("path", {
  fill: "#EC1212",
  d: "M6.311 2.26c-.5 0-1.052-.858-2.67-.858-1.62 0-2.248.858-2.833.858S2.001.035 3.538.035C5.164.035 6.813 2.26 6.31 2.26z"
})), React.createElement("g", {
  transform: "translate(5.31 7.586)"
}, React.createElement("path", {
  fill: "#EC1212",
  d: "M.932.732c1.184 0 1.957.594 2.679 1.254.226.208.888.814.888 1.146 0 .337-.495-.085-.715-.24-.787-.55-1.258-.944-2.18-1.25C1.386 1.57.226 1.537.089 1.249-.076.9.669.732.932.732z"
})), React.createElement("g", {
  transform: "translate(12.138 7.586)"
}, React.createElement("path", {
  fill: "#EC1212",
  d: "M4.089.732c-1.184 0-1.957.594-2.68 1.254-.226.208-.888.814-.888 1.146 0 .337.496-.085.715-.24.788-.55 1.258-.944 2.182-1.25.216-.072 1.377-.105 1.514-.393C5.097.9 4.352.732 4.09.732z"
})));

var SvgAngry = function SvgAngry(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAngry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Angry.22f73540.svg";
export { ForwardRef as ReactComponent };